// @flow

import React from "react";
import SVG from "react-inlinesvg";
import { Button } from "buba-components-ts";
import Doc from "buba-components/src/assets/icons/file/doc.svg";

import styles from "./DownloadInquiryDocuments.scss";

type Props = {
  handleDownload: () => void
};

const DownloadInquiryDocuments = ({ handleDownload }: Props) => {
  return (
    <div className={styles.wrapper}>
      <SVG className={styles.docIcon} src={Doc} />
      <span className={styles.requestText}>Antragsdokumente</span>
      <Button
        type="button"
        size="medium"
        customStyles={styles.downloadButton}
        onClick={handleDownload}
      >
        Herunterladen
      </Button>
    </div>
  );
};

export default DownloadInquiryDocuments;
